import axios from 'axios';

interface EnvironmentApi {
	api: {
		productList: string;
	}
}

interface Chain {
	chainIdentifierAbbr: string;
}

const getProductListData = (queryParams: object, host: string, environment: EnvironmentApi, chain: Chain, additionalHeaders: object): Promise<any> => {
	const url = environment.api.productList;
	const params = encodeURIComponent(JSON.stringify(queryParams));
	const requestUrl = `${url}v2/search?searchVO=${params}`;

	const httpHeaders = {
		'X-TIMEOUT': '7500',
		'Content-Type': 'application/json',
		channel: chain.chainIdentifierAbbr,
		origin: `${host}`,
		...additionalHeaders
	};

	if (url.includes('prodauth')) {
		httpHeaders['preview'] = 'rule';
	}

	const httpOptions = {
		headers: httpHeaders
	};

	// Make the XHR
	return axios.get(requestUrl, httpOptions).then((response) =>
		// Return just the data from the Axios response
		 response.data
	).catch(() =>
		// Return undefined
		 undefined
	);
};

export { getProductListData };